import * as React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import styles from './PushNotificationPrompt.css';
import Modal from 'components/Modal';
import PushNotificationWrapperComponent from './PushNotificationWrapperComponent';
export const WEB_PUSH_MODAL_ID = 'web-push-prompt';
export const PushNotificationPrompt = (props) => {
    const { modal } = props;
    const modalId = get(modal, 'id');
    if (modalId !== WEB_PUSH_MODAL_ID) {
        return null;
    }
    // Don't show modal if webpush is not supported or when permission state is GRANTED.
    return (<Modal active closeOnOverlayClick closeOnEscape manual contentClassName={styles['push-modal']} overlayClassName={styles['push-overlay']}>
			<PushNotificationWrapperComponent {...props}/>
		</Modal>);
};
const mapStateToProps = state => {
    return {
        modal: state.modal
    };
};
export default connect(mapStateToProps)(PushNotificationPrompt);
